import Animation from '../../animations/add-breakdown-animation'
import StyleTweeners from '../style-tweeners'
import { EPSILON } from 'chart-constants'

class AddBreakdownAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  animate (serie, entering, selection, merged, exiting) {
    super.animate(serie, entering, selection, merged, exiting)

    // The points are hidden, we want to show them and fade them in
    selection.selectAll('.point')
             .style('display', 'block')
             .style('opacity', 1)

    merged.selectAll('.point')
          .style('opacity', EPSILON) // Fade out the points
          .end().then(() => {
            merged.selection()
                  .selectAll('.point')
                  .style('opacity', 1)
                  .style('display', '') // remove the display property
          })

    // Fade in the path once the transitio is 50% finished
    merged.tween('fade-in', this.styleTweeners.fadeIn(merged, false, .5))
          .tween('shrink-stroke', this.styleTweeners.shrinkStroke(merged))
  }

}

export default AddBreakdownAnimation
